<template>
<section>
  <button @click="wipedb">wipe</button><button @click="exportdb">export</button>
  <button @click="replicate">replicate</button>
  <button @click="unclone">unclone</button>
  <button @click="metaclone">metaclone</button>
  <button @click="metas">metas</button>
  <hider>
  <div v-for="o in bases" :key="o">
  <hr>
    {{ o }}:
    <json-viewer :value="meta(o).rows" :expand-depth=2 copyable boxed sort></json-viewer>
  </div>
  </hider>
</section>
</template>
<script>
import JsonViewer from 'vue-json-viewer'
import Hider from '@/components/base/Hider.vue'
import { exportdb, reset, } from '@/lib/databases'

export default {
    components: { JsonViewer, Hider, },
    mounted () {
        let { commandes, customers, options } = this.$db;
        async function go(d) {
            const ocommandes = await commandes.allDocs({include_docs: true}).catch(console.log);
            d.commandes = ocommandes || [];
            const ocustomers = await customers.allDocs({include_docs: true}).catch(console.log);
            d.customers = ocustomers || [];
            const ooptions = await options.allDocs({include_docs: true}).catch(console.log);
            d.options = ooptions || [];
        }
        go(this);
    },
    data () {
        return {
            bases: ["commandes", "customers", "options"],
            customers: [],
            commandes: [],
            options: []
        }
    },
    methods: {
        meta (n) { return this[n]; },
        metas () { this.$meta.metas(); },
        metaclone () {
          let { customers, commandes, options } = this.$db
          this.$meta.metaclone([ customers, commandes, options ]);
        },
        unclone () {
          this.$meta.destroy(this.bases.map(n => n + '1'))
        },
        replicate () {
          this.bases.forEach(b => this.$meta.locrep(this.$db[b]));
        },
        exportdb () { return exportdb(); },
        wipedb () {
            let ans = confirm('wipe ?');
            if (!ans) { return; }
            this.bases.forEach(b => reset(this.$db,b));
            this.$toasted.error('databases wiped'); // more a warning but alas
            this.$router.push('/');
        }
    },
}
</script>
